import React, {useEffect, useState} from 'react';

import './sessionPriceComponent.css';

const SessionPriceComponent = ({paymentFlowBasedSessionDto = null}) => {
  const [sessionPriceTxt, setSessionPriceTxt] = useState(null);

  useEffect(() => {
    if (paymentFlowBasedSessionDto) {
      const sessionPrice = paymentFlowBasedSessionDto.sessionCost;
      const sessionCurrency = paymentFlowBasedSessionDto.sessionCurrency;
      const sessionPriceTxt = `${sessionPrice} ${sessionCurrency}`;
      setSessionPriceTxt(sessionPriceTxt);
    } else {
      setSessionPriceTxt(null);
    }
  }, [paymentFlowBasedSessionDto]);

  return (
    sessionPriceTxt && (
      <div className="et-v2-session-price-container">
        <div className="et-v2-spc-session-price-txt">Session price:</div>
        <div className="et-v2-spc-session-price">{sessionPriceTxt}</div>
      </div>
    )
  );
};

export default SessionPriceComponent;
